export default {
    install(Vue) {
        Vue.prototype.$loading = function(show = true, fullScreen = true) {
            let msg = '';
            if (typeof show === 'string') {
                msg = show;
                show = true;
            }
            this.$store.commit('base/loadingMessage', msg);
            this.$store.commit('base/setLoading', { isLoading: show, fullScreen });
        }
    }
}